import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { openSetReceivedDateModal } from '../../../../../../../store/returns/details/returns.details.actions';
import { RETURN_ACTION_MARK_RECEIVED_CLICKED } from '../../../../../../../constants/analytics-events';
import { Segment } from '../../../../../../../services/analytics-services/segment';

import messages from '../../../../../rate-card/read-only/label-actions/messages';

export const MarkAsReceived = ({ returnFulfillmentId }) => {
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    Segment.trackEvent(RETURN_ACTION_MARK_RECEIVED_CLICKED, {
      type: RETURN_ACTION_MARK_RECEIVED_CLICKED,
      enhanced: false,
      fulfillmentId: returnFulfillmentId,
    });
    dispatch(openSetReceivedDateModal(returnFulfillmentId));
  }, [dispatch, returnFulfillmentId]);

  return (
    <DropdownMenuItem onClick={onClick}>
      <FormattedMessage {...messages.markAsReceived} />
    </DropdownMenuItem>
  );
};

MarkAsReceived.propTypes = {
  returnFulfillmentId: PropTypes.string.isRequired,
};
